// extracted by mini-css-extract-plugin
module.exports = {"container":"filter_dropdown_box-module__container--P61ac"};